import { Recurrency } from '../../graphql/types';
import { Stack } from '@mui/material';
import CopyTextIconButton from '../../components/CopyTextIconButton';
import React from 'react';

export interface Props {
  recurrency: Recurrency;
}

const RecurrencyTitle = ({ recurrency }: Props) => {
  if (recurrency.integration.type === 'ACH_PROC') {
    return (
      <Stack direction={'row'} sx={{ pt: 1.75, fontSize: 14, fontWeight: 'bold' }}>
        <Stack direction={'row'}>
          Schedule Name: {recurrency.referenceMca}{' '}
          <CopyTextIconButton textToCopy={recurrency.referenceMca} dispatchText={'Recurrency Title'} />
        </Stack>
        {recurrency.referenceRecurrence && <Stack direction={'row'}>Schedule Description: {recurrency.referenceRecurrence}</Stack>}
      </Stack>
    );
  }

  if (recurrency.integration.type === 'GO_ACH_BOT' || recurrency.integration.type === 'GO_ACH') {
    return (
      <Stack direction={'row'} sx={{ pt: 1.75, fontSize: 14, fontWeight: 'bold' }}>
        <Stack direction={'row'}>
          Client Name: {recurrency.referenceMca} <CopyTextIconButton textToCopy={recurrency.referenceMca} dispatchText={'Client Name'} />
        </Stack>
        <Stack direction={'row'}>
          Bank Account Name: {recurrency.referenceRecurrence || recurrency.referenceMca}{' '}
          <CopyTextIconButton
            textToCopy={recurrency.referenceRecurrence || recurrency.referenceMca}
            dispatchText={'Bank Account Name'}
          />
        </Stack>
      </Stack>
    );
  }

  if (recurrency.integration.type === 'CLEAR_ACH_BOT') {
    return (
      <Stack direction={'row'} sx={{ pt: 1.75, fontSize: 14, fontWeight: 'bold' }}>
        <Stack direction={'row'}>
          Customer Name: {recurrency.referenceMca}{' '}
          <CopyTextIconButton textToCopy={recurrency.referenceMca} dispatchText={'Customer Name'} />
        </Stack>
        <Stack direction={'row'}>
          Subscription name: {recurrency.referenceRecurrence}{' '}
          <CopyTextIconButton textToCopy={recurrency.referenceRecurrence || ''} dispatchText={'Subscription Name'} />
        </Stack>
      </Stack>
    );
  }

  return (
    <Stack direction={'row'}>
      ACH Processor Data: {recurrency.referenceRecurrence || recurrency.referenceMca}{' '}
      <CopyTextIconButton textToCopy={recurrency.referenceRecurrence || recurrency.referenceMca} dispatchText={'ACH Processor Data'} />
    </Stack>
  );
};

export default RecurrencyTitle;
